/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import { API_URL } from "../../constants/apiUrl";
import { EMPLOYEE_MANAGE_API } from "../../constants/constants";
import { useUploadEmployeeBkashDataMutation } from "../../features/employee/employeeApi";
import useDownloadEmployeeXlsx from "../../hooks/useDownloadExcelWithApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import {
  EmployeeData,
  GetEmployeeParamsType,
  ModalComponentProps,
} from "../../types";
import UploadExcelModal from "../common/UploadExcelModal";
import SuccessModal from "../Report/SuccessModal";

interface BKashNumberModalParams extends ModalComponentProps {
  employeeParams: GetEmployeeParamsType;
}

export default function BKashNumberModal({
  open,
  handleClose,
  employeeParams,
}: BKashNumberModalParams) {
  // const navigate = useNavigate();
  const { loading: excelLoading, downloadXlsx } = useDownloadEmployeeXlsx();
  const [uploadEmployeeData, { isLoading, isError, error, isSuccess }] =
    useUploadEmployeeBkashDataMutation();
  useError(isError, error, "Upload bKash data fail");
  const [formData, setFormData] = useState<FormData | null>(null);
  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  const handleDownload = () => {
    downloadXlsx(
      EMPLOYEE_MANAGE_API + API_URL.getEmployees,
      { ...employeeParams, skip: 0, limit: 0 },
      "Coworker_Bkash_Number",
      "employees",
      (employee: EmployeeData) => {
        return {
          "Employee Name": employee?.member?.profile?.name ?? "-",
          "Employee Email": employee?.member?.profile?.email ?? "-",
          "bKash Number": employee?.bkash_info?.account_no ?? "-",
        };
      }
    );
  };

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "bKash number updated successfully");
      handleOpen({ type: "SUCCESS" });
      // if (data?.data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
    }
  }, [handleClose, isSuccess]);

  return (
    <>
      <UploadExcelModal
        open={open}
        handleClose={handleClose}
        isLoading={false}
        handler={setFormData}
        title="Update bKash Number Data in Bulk"
        warningText="First download the active Employee informations and upload it after editing desired informations."
        downloadLink={"/Coworker_Bkash_Number_Sample.xls"}
        footer={
          <Space size={12}>
            {childOpen?.type === "SUCCESS" && (
              <SuccessModal
                type="queue"
                open={childOpen?.open}
                handleClose={childClose}
              />
            )}
            <Button
              className="outline-button-primary modal-button"
              icon={<DownloadIcon />}
              loading={excelLoading}
              onClick={handleDownload}
            >
              Download Existing Data
            </Button>
            <Button
              className="modal-button"
              type="primary"
              loading={isLoading}
              onClick={() => uploadEmployeeData(formData)}
            >
              Upload
            </Button>
          </Space>
        }
      />
    </>
  );
}
